import Vue from 'vue';

// Domain
import { UpdateAccountNumberStateManager } from '../../domain/state-manager/update-account-number-state-manager';
import UpdateAccountNumberState from '../../domain/state/update-account-number-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export class UpdateAccountNumberVueStateManager implements
  UpdateAccountNumberStateManager {
  private _state: UpdateAccountNumberState = Vue.observable<
    UpdateAccountNumberState>(
      new UpdateAccountNumberState(),
    );

  private readonly observers: Observer[] = [];

  get state(): UpdateAccountNumberState {
    return this._state;
  }

  set state(value: UpdateAccountNumberState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<UpdateAccountNumberState>) {
    type Keys = keyof UpdateAccountNumberState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
